import React from 'react';

import { ButtonProps } from './interface';
import { InternalButton } from './InternalButton';

export const Button: React.FC<ButtonProps> = InternalButton;
